import { FC, ReactElement } from 'react';
import { SfuModels, StreamVideoParticipant } from '@stream-io/video-react-sdk';
import i18next from 'i18next';
import NetworkQualityBars from './NetworkQualityBars';

type NetworkQualityPillProps = {
  participant: StreamVideoParticipant;
};

const NetworkQualityPill: FC<NetworkQualityPillProps> = ({ participant }: NetworkQualityPillProps): ReactElement => {
  const qualityLabelMap: Partial<Record<SfuModels.ConnectionQuality, string>> = {
    [SfuModels.ConnectionQuality.EXCELLENT]: i18next.t('callPage.networkQuality.excellent'),
    [SfuModels.ConnectionQuality.GOOD]: i18next.t('callPage.networkQuality.good'),
    [SfuModels.ConnectionQuality.POOR]: i18next.t('callPage.networkQuality.poor'),
  };

  const qualityLabel: string = qualityLabelMap[participant.connectionQuality] ?? i18next.t('callPage.networkQuality.connecting');

  return (
    <div
      className="d-flex align-items-center gap-2 px-3"
      style={{
        backgroundColor: '#122033',
        borderRadius: '999px',
        minHeight: '34px',
        color: '#ffffff',
      }}
    >
      <NetworkQualityBars quality={participant.connectionQuality} />
      <span className="fw-semibold small">{qualityLabel}</span>
    </div>
  );
};

export default NetworkQualityPill;